import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'zbp-toggle-switch',
  imports: [CommonModule, ReactiveFormsModule, NgbTooltip],
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent {
  @Input() isChecked: boolean;
  @Input() toggleLabel: string;
  @Input() labelTooltip: string;
  /** Unique identifier of the toggle */
  @Input() internalId: string;
  @Output() toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  onToggleChange(): void {
    this.isChecked = !this.isChecked;
    this.toggleChange.emit(this.isChecked);
  }
}
